import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* kibanaLoginSaga(action: types.KibanaLoginActionType) {
  try {
    const response = yield call(services.kibanaLoginService, action.payload);
    if (response.data) {
      log.info("kibanaLoginSaga: GOOD!");
      yield put({ type: actions.KIBANA_LOGIN_SUCCESS, response });
    } else if (response.error) {
      throw response;
    } else {
      log.info("kibanaLoginSaga: BAD!");
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.KIBANA_LOGIN_ERROR, response: error });
  }
}
